import React from 'react';
import '../styles/alertaDeCasillaUno.css';

//Imagenes
import gusano from '../imgs/otros/oruga.png';
import letrero from '../imgs/otros/Letrero con lectura.png';

const AlertaDeCasillaUno = (props) => {
    const { setCasillaUnoActivacion } = props;


    return (
        <div className='alertaDeCasillaUno__div--container'>
            <img className='alertaDeCasillaUno__img alertaDeCasillaUno__img--gusano' src={gusano} alt='gusano'/>
            <img className='alertaDeCasillaUno__img alertaDeCasillaUno__img--letrero' src={letrero} alt='letrero'/>
            <button className='alertaDeCasillaUno__button' onClick={() => setCasillaUnoActivacion(false)}>De acuerdo</button>
        </div>
    )
};

export default AlertaDeCasillaUno;